var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudSnowLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3274 38.8288C48.2792 38.8288 52.3307 34.7773 52.3307 29.8255C52.3307 24.8737 48.2792 20.8222 43.3274 20.8222C42.6521 12.044 35.4495 5.06641 26.4462 5.06641C17.4429 5.06641 10.0151 12.269 9.56498 21.0473C5.73857 21.9476 2.8125 25.5489 2.8125 29.8255C2.8125 34.7773 6.86399 38.8288 11.8158 38.8288",
    stroke: "#60b0cc",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5713 29.8242V47.8308",
    stroke: "#60b0cc",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8066 34.3281L35.3373 43.3314",
    stroke: "#60b0cc",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8066 43.3314L35.3373 34.3281",
    stroke: "#60b0cc",
    strokeWidth: 2.53218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSnowLb);
export default __webpack_public_path__ + "static/media/cloud-snow-lb.ee01045ee5bd7016659a06e269ead981.svg";
export { ForwardRef as ReactComponent };